<template>
<div class="myheader">
<div id="left">
  <div><img src="~@/assets/header_img/chinese.png" id="chinese"></div>
  <div id="div"></div>
  <div><img src="~@/assets/header_img/huzer.png" id="huzer"></div>
</div>

<div id="right">
<ul id="leader">
  <li><a href="/">主页</a></li>
  <li class="drop-down" @click="show">关于我们
    <ul id="aboutMe">
      <li><a href="#/introduce">企业简介</a></li>
      <li><a href="#/experience">成长历程</a></li>
      <li><a href="#/business">企业资质</a></li>
      <li><a href="#/address">企业地图</a></li>
      <li><a href="#/contact">联系我们</a></li>
    </ul>
  </li>
  <li><a href="#/brand">品牌与产品</a></li>
  <li  class="drop-down" @click="showt">商用解决方案
    <ul id="idea">
      <li><a href="#/work">企业业绩</a></li>
      <li><a href="#/success">成功案例</a></li>
    </ul>
  </li>
  <li><a href="#/buy">购买渠道</a></li>
  <li><a href="#/education">家庭教育</a></li>
  <li><a href="#/soft">外语学习软件</a></li>
  <li  class="drop-down" @click="showT">加入我们
    <ul id="addMe">
      <li><a href="#/hiring">招贤纳士</a></li>
      <li><a href="#/agency">成为经销商</a></li>
    </ul>
  </li>
</ul>
</div>
<div class="adjust">
  <img src="~@/assets/common_img/more.png" id="more" @click="showlead">
  <img src="~@/assets/common_img/close.png" id="close" @click="closelead">
</div>
    <div id="phoneShow">
      <div class="showLogo">
        <div><img src="~@/assets/header_img/chinese.png" class="logo-chinese"/></div>
        <div class="line"></div>
        <div><img src="~@/assets/header_img/huzer.png" class="logo-huzer"/></div>
      </div>
      <ul class="first-ul">
        <li><a href="/">首页</a></li>
        <li><a href="#/introduce">关于我们</a></li>
        <ul class="second-ul">
        <li class="second"><a href="#/introduce">企业简介</a></li>
        <li class="second"><a href="#/experience">成长历程</a></li>
        <li class="second"><a href="#/business">企业资质</a></li>
        <li class="second"><a href="#/address">企业地图</a></li>
        <li class="second"><a href="#/contact">联系我们</a></li>
        </ul>
        <li><a href="#/brand">品牌与产品</a></li>
        <li><a href="#/work">商用解决方案</a></li>
        <ul class="second-ul">
        <li class="second"><a href="#/work">企业业绩</a></li>
        <li class="second"><a href="#/success">成功案例</a></li>
        </ul>
        <li><a href="#/buy">购买渠道</a></li>
        <li><a href="#/hiring">加入我们</a></li>
        <li><a href="#/education">家庭教育</a></li>
        <li><a href="#/soft">外语学习软件</a></li>
        <ul class="second-ul">
        <li class="second"><a href="#/hiring">招贤纳士</a></li>
        <li class="second"><a href="#/agency">成为经销商</a></li>
        </ul>
      </ul>
    </div>
</div>
</template>
<script>
export default{
  name: 'header',
  data () {
    return {

    }
  },
  methods: {
    show () {
      var target = document.getElementById('aboutMe')
      if (target.style.visibility === 'visible') {
        target.style.visibility = 'hidden'
      } else {
        target.style.visibility = 'visible'
      }
    },
    showt () {
      var target = document.getElementById('idea')
      if (target.style.visibility === 'visible') {
        target.style.visibility = 'hidden'
      } else {
        target.style.visibility = 'visible'
      }
    },
    showT () {
      var target = document.getElementById('addMe')
      if (target.style.visibility === 'visible') {
        target.style.visibility = 'hidden'
      } else {
        target.style.visibility = 'visible'
      }
    },
    loginin () {
      document.getElementById('loginin').style.visibility = 'visible'
    },
    off () {
      document.getElementById('loginin').style.visibility = 'hidden'
    },
    sure () {
      var id = document.getElementById('Cid').value
      var password = document.getElementById('password').value
      if (password === '') {
        alert('请输入密码')
      } else {
        var that = this
        this.$axios.post('http://' + this.global.url + ':8081/api/user/password', this.$qs.stringify({
          Cid: id
        }))
          .then(function (res) {
            console.log(res.data)
            var psw = res.data[0].password
            console.log(psw + '------')
            if (psw === password) {
              that.$router.push({path: '/loginin'})
            }
          })
          .catch(function (res) {
            console.log(res)
          })
      }
    },
    showlead () {
      document.getElementById('phoneShow').style.display = 'block'
      document.getElementById('more').style.display = 'none'
      document.getElementById('close').style.display = 'block'
    },
    closelead () {
      document.getElementById('phoneShow').style.display = 'none'
      document.getElementById('close').style.display = 'none'
      document.getElementById('more').style.display = 'block'
    }
  }
}
</script>
<style scoped>
*{
  margin: 0;
  padding: 0;
}
#leader>li:hover{
  color: #F15A24;
}
#leader>li>a:hover{
  color: #F15A24;
}
#aboutMe>li>a:hover,#idea>li>a:hover,#addMe>li>a:hover{
  color: #F15A24;
}
.myheader{
  width: 100%;
  height: auto;
}
@media screen and (min-width: 1500px){
  #left {
    width: 20%;
    float: left;
    margin-left: 5%;
    margin-top: 40px;
    display: flex;
  }
  #div {
    width: 1.5%;
    height: 86px;
    background-color: #f15a24;
  }
  #huzer {
    width: 92%;
    height: auto;
    margin-top: 10%;
  }
  #chinese {
    width: 92%;
    height: auto;
  }
  #right {
    width: 65%;
    height: 20px;
    float: right;
    margin-right: 5%;
    margin-top: 70px;
    /* border:red 1px solid; */
  }
  #leader {
    width: 100%;
    height: auto;
    list-style: none;
  }
  #leader > li {
    float: left;
    margin-left: 3%;
    font-size: 20px;
    font-family: "宋体";
    cursor: pointer;
  }
  #leader > li > a {
    color: black;
    text-decoration: none;
    display: block;
    font-size: 20px;
    font-family: "宋体";
  }
  .drop-down {
    /* height: 19px; */
    overflow: hidden;
  }
  #aboutMe,
  #idea,
  #addMe {
    list-style: none;
    padding: 0;
    visibility: hidden;
    /* border:red 1px solid; */
  }
  #leader .drop-down:hover {
    overflow: visible;
  }
  #aboutMe > li > a,
  #idea > li > a,
  #addMe > li > a {
    color: white;
    text-decoration: none;
    display: block;
    font-size: 20px;
    font-family: "宋体";
    width: auto;
    height: 20px;
    background-color: rgb(172, 168, 168);
    position: relative;
    z-index: 99;
  }
  #aboutMe > li,
  #idea > li,
  #addMe > li {
    margin-top: 1px;
  }
  #more,#close,#phoneShow{
    display: none;
  }
  .showLogo{display: none;}
  .first-ul{display: none;}
  .adjust{display: none;}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  #left {
    width: 20%;
    float: left;
    margin-left: 3%;
    margin-top: 30px;
    display: flex;
  }
  #div {
    width: 1.5%;
    height: 86px;
    background-color: #f15a24;
  }
  #huzer {
    width: 92%;
    height: auto;
    margin-top: 10%;
  }
  #chinese {
    width: 92%;
    height: auto;
  }
  #right {
    width: 70%;
    height: 20px;
    float: right;
    margin-right: 5%;
    margin-top: 50px;
  }
  #leader {
    width: 100%;
    height: auto;
    list-style: none;
  }
  #leader > li {
    float: left;
    margin-left: 2%;
    font-size: 18px;
    font-family: "宋体";
    cursor: pointer;
  }
  #leader > li > a {
    color: black;
    text-decoration: none;
    display: block;
    font-size: 18px;
    font-family: "宋体";
  }
  .drop-down {
    overflow: hidden;
  }
  #aboutMe,
  #idea,
  #addMe {
    list-style: none;
    padding: 0;
    visibility: hidden;
  }
  #leader .drop-down:hover {
    overflow: visible;
  }
  #aboutMe > li > a,
  #idea > li > a,
  #addMe > li > a {
    color: white;
    text-decoration: none;
    display: block;
    font-size: 18px;
    font-family: "宋体";
    width: auto;
    height: 18px;
    background-color: rgb(172, 168, 168);
    position: relative;
    z-index: 99;
  }
  #aboutMe > li,
  #idea > li,
  #addMe > li {
    margin-top: 1px;
  }
  #more,#close,#phoneShow{
    display: none;
  }
  .showLogo{display: none;}
  .first-ul{display: none;}
  .adjust{display: none;}
}
@media screen and (min-width: 960px) and (max-width:1199px){
  #left {
    width: 20%;
    float: left;
    margin-left: 5%;
    margin-top: 20px;
    display: flex;
  }
  #div {
    width: 1.5%;
    height: 66px;
    background-color: #f15a24;
  }
  #huzer {
    width: 92%;
    height: auto;
    margin-top: 10%;
  }
  #chinese {
    width: 92%;
    height: auto;
  }
  #right {
    width: 75%;
    height: 20px;
    float: right;
    margin-right: 0%;
    margin-top: 40px;
  }
  #leader {
    width: 100%;
    height: auto;
    list-style: none;
  }
  #leader > li {
    float: left;
    margin-left: 2%;
    font-size: 16px;
    font-family: "宋体";
    cursor: pointer;
  }
  #leader > li > a {
    color: black;
    text-decoration: none;
    display: block;
    font-size: 16px;
    font-family: "宋体";
  }
  .drop-down {
    overflow: hidden;
  }
  #aboutMe,
  #idea,
  #addMe {
    list-style: none;
    padding: 0;
    visibility: hidden;
  }
  #leader .drop-down:hover {
    overflow: visible;
  }
  #aboutMe > li > a,
  #idea > li > a,
  #addMe > li > a {
    color: white;
    text-decoration: none;
    display: block;
    font-size: 16px;
    font-family: "宋体";
    width: auto;
    height: 16px;
    background-color: rgb(172, 168, 168);
    position: relative;
    z-index: 99;
  }
  #aboutMe > li,
  #idea > li,
  #addMe > li {
    margin-top: 1px;
  }
  #more,#close,#phoneShow{
    display: none;
  }
  .showLogo{display: none;}
  .first-ul{display: none;}
  .adjust{display: none;}
}
@media screen and (min-width: 768px) and (max-width:959px){
  #left {
    width: 20%;
    float: left;
    margin-left: 5%;
    margin-top: 20px;
    display: flex;
  }
  #div {
    width: 1.5%;
    height: 46px;
    background-color: #f15a24;
  }
  #huzer {
    width: 92%;
    height: auto;
    margin-top: 10%;
  }
  #chinese {
    width: 92%;
    height: auto;
  }
  #right {
    width: 75%;
    height: 20px;
    float: right;
    margin-right: 0%;
    margin-top: 35px;
  }
  #leader {
    width: 100%;
    height: auto;
    list-style: none;
  }
  #leader > li {
    float: left;
    margin-left: 2%;
    font-size: 12px;
    font-family: "宋体";
    cursor: pointer;
  }
  #leader > li > a {
    color: black;
    text-decoration: none;
    display: block;
    font-size: 12px;
    font-family: "宋体";
  }
  .drop-down {
    overflow: hidden;
  }
  #aboutMe,
  #idea,
  #addMe {
    list-style: none;
    padding: 0;
    visibility: hidden;
  }
  #leader .drop-down:hover {
    overflow: visible;
  }
  #aboutMe > li > a,
  #idea > li > a,
  #addMe > li > a {
    color: white;
    text-decoration: none;
    display: block;
    font-size: 12px;
    font-family: "宋体";
    width: auto;
    height: 12px;
    background-color: rgb(172, 168, 168);
    position: relative;
    z-index: 99;
  }
  #aboutMe > li,
  #idea > li,
  #addMe > li {
    margin-top: 1px;
  }
  #more,#close,#phoneShow{
    display: none;
  }
  .showLogo{display: none;}
  .first-ul{display: none;}
  .adjust{display: none;}
}
@media screen and (min-width: 702px) and (max-width:767px){
  #left {
    width: 15%;
    float: left;
    margin-left: 3%;
    margin-top: 10px;
    display: flex;
  }
  #div {
    width: 1.5%;
    height: 26px;
    background-color: #f15a24;
  }
  #huzer {
    width: 92%;
    height: auto;
    margin-top: 10%;
  }
  #chinese {
    width: 92%;
    height: auto;
  }
  #right {
    width: 75%;
    height: 20px;
    float: right;
    margin-right: 0%;
    margin-top: 20px;
  }
  #leader {
    width: 100%;
    height: auto;
    list-style: none;
  }
  #leader > li {
    float: left;
    margin-left: 1%;
    font-size: 12px;
    font-family: "宋体";
    cursor: pointer;
  }
  #leader > li > a {
    color: black;
    text-decoration: none;
    display: block;
    font-size: 12px;
    font-family: "宋体";
  }
  .drop-down {
    overflow: hidden;
  }
  #aboutMe,
  #idea,
  #addMe {
    list-style: none;
    padding: 0;
    visibility: hidden;
  }
  #leader .drop-down:hover {
    overflow: visible;
  }
  #aboutMe > li > a,
  #idea > li > a,
  #addMe > li > a {
    color: white;
    text-decoration: none;
    display: block;
    font-size: 12px;
    font-family: "宋体";
    width: auto;
    height: 12px;
    background-color: rgb(172, 168, 168);
    position: relative;
    z-index: 99;
  }
  #aboutMe > li,
  #idea > li,
  #addMe > li {
    margin-top: 1px;
  }
  #more,#close,#phoneShow{
    display: none;
  }
  .showLogo{display: none;}
  .first-ul{display: none;}
  .adjust{display: none;}
}
@media screen and (max-width:701px){
  .myheader {
    width: 100%;
    height: auto;
  }
  #left {
    width: 20%;
    float: left;
    margin-left: 10%;
    margin-top: 20px;
    display: flex;
    display: none;
  }
  #div {
    width: 1.5%;
    height: 38px;
    background-color: #f15a24;
  }
  #huzer {
    width: 92%;
    height: auto;
    margin-top: 10%;
  }
  #chinese {
    width: 92%;
    height: auto;
  }
  #right {
    width: 60%;
    height: 22px;
    float: right;
    margin-right: 10%;
    margin-top: 40px;
    display: none;
  }
  #leader {
    width: 100%;
    height: auto;
    list-style: none;
  }
  #leader > li {
    float: left;
    margin-left: 1%;
    font-size: 22px;
    font-family: "宋体";
    cursor: pointer;
  }
  #leader > li > a {
    color: black;
    text-decoration: none;
    display: block;
    font-size: 22px;
    font-family: "宋体";
  }
  .drop-down {
    overflow: hidden;
  }
  #aboutMe,
  #idea,
  #addMe {
    list-style: none;
    padding: 0;
    visibility: hidden;
  }
  #leader .drop-down:hover {
    overflow: visible;
  }
  #aboutMe > li > a,
  #idea > li > a,
  #addMe > li > a {
    color: white;
    text-decoration: none;
    display: block;
    font-size: 22px;
    font-family: "宋体";
    width: auto;
    height: 27px;
    background-color: rgb(172, 168, 168);
    position: relative;
    z-index: 99;
  }
  #aboutMe > li,
  #idea > li,
  #addMe > li {
    margin-top: 1px;
  }
  /* 适应手机 */
  #more{
    width: 20px;
    height: auto;
  float: right;
  margin-right: 5%;
  margin-top: 8px;
  display: block;
}
#close{
  width: 20px;
    height: auto;
  float: right;
  margin-right: 5%;
  margin-top: 8px;
  display: none;
}
#phoneShow{
  width: 40%;
  height: auto;
  background-color: black;
  opacity: 0.9;
  display: none;
  padding-bottom: 50px;
  position: absolute;
  z-index: 99;
}
#phoneShow li{
  text-align: center;
  color: rgb(56, 56, 56);
  margin-top: 20px;
  cursor: pointer;
}
.second-ul{
  list-style: none;
  width: 60%;
  /* height: 100px; */
  background-color: rgb(231, 230, 230);
  font-size: 12px;
  /* color: #f15a24; */
  text-align: center;
  margin-left: 20%;
  border-radius: 5px;
}
.second-ul li:first-child{
padding-top: 10px;
}
.second-ul li:last-child{
  padding-bottom: 10px;
}
.second-ul li a{
  text-decoration: none;
}
.first-ul>li a{
text-decoration: none;
}
.first-ul>li a:link{
  color: rgb(56, 56, 56)
}
.first-ul>li a:visited{
  color: rgb(56, 56, 56)
}
.first-ulli a:hover{
  color: rgb(56, 56, 56)
}
.second-ul li a:link{
color: rgb(56, 56, 56);
}
.second-ul li a:visited{
color: rgb(56, 56, 56);
}
.second-ul li a:hover{
color: rgb(56, 56, 56);
}
.showLogo{
  display: flex;
  padding-top: 40px;
  padding-left: 22%;
}
.logo-chinese{
  width: 40px;
  height: auto;
}
.line{
  width: 2px;
  height: 40px;
  background-color: #f15a24;
}
.logo-huzer{
  width: 70px;
  height: auto;
  margin-top: 10px;
}
}

</style>



// WEBPACK FOOTER //
// src/components/header/header_0.vue